/**
 * KNN Goto
 * Global click handler: any element with class "goto" scrolls the page to
 * the element whose id matches its data-goto attribute, e.g.
 * <button class="goto" data-goto="section-id">Jump</button>
 */
(() => {
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.goto');
    if (!trigger) return;

    const targetId = trigger.dataset.goto;
    if (!targetId) return;

    const target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
      block: 'start',
    });
  });
})();
